import React from 'react';
import { Copy, Check } from 'lucide-react';

const Documentation = () => {
    const [copied, setCopied] = React.useState(false);

    const handleCopy = () => {
        const curl = `curl -X POST https://veo-banana.croosh.workers.dev/generate \\
  -H "Content-Type: application/json" \\
  -d '{
    "prompt": "A cinematic shot of a banana peeling itself",
    "aspectRatio": "16:9"
  }'`;
        navigator.clipboard.writeText(curl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>API Documentation</h2>
                <p>Simple guide to use the video generation API</p>
            </div>

            <div className="content-card">
                <h3>Generate Video</h3>
                <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
                    Create a new video generation task.
                </p>

                <div className="form-group">
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <span className="mode-badge" style={{ background: 'var(--primary)', color: 'white' }}>POST</span>
                        <code style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}>/generate</code>
                    </div>
                </div>

                <div className="form-group">
                    <label>Request Body (JSON)</label>
                    <div style={{
                        background: 'var(--input-bg)',
                        padding: '1rem',
                        borderRadius: '0.5rem',
                        border: '1px solid var(--border)',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap'
                    }}>
                        {`{
  "prompt": "string",      // Description of the video
  "aspectRatio": "string"  // e.g., "16:9", "9:16"
}`}
                    </div>
                </div>

                <div className="form-group">
                    <label>Response (JSON)</label>
                    <div style={{
                        background: 'var(--input-bg)',
                        padding: '1rem',
                        borderRadius: '0.5rem',
                        border: '1px solid var(--border)',
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        whiteSpace: 'pre-wrap'
                    }}>
                        {`{
  "id": "string",       // Task ID
  "batchId": "string"   // Batch ID
}`}
                    </div>
                </div>

                <div className="form-group">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                        <label style={{ marginBottom: 0 }}>Example Usage (cURL)</label>
                        <button
                            onClick={handleCopy}
                            className="btn-icon"
                            title="Copy to clipboard"
                        >
                            {copied ? <Check size={16} color="var(--success)" /> : <Copy size={16} />}
                        </button>
                    </div>
                    <div style={{
                        background: 'var(--input-bg)',
                        padding: '1rem',
                        borderRadius: '0.5rem',
                        border: '1px solid var(--border)',
                        fontFamily: 'monospace',
                        fontSize: '0.85rem',
                        whiteSpace: 'pre-wrap',
                        overflowX: 'auto'
                    }}>
                        {`curl -X POST https://veo-banana.croosh.workers.dev/generate \\
  -H "Content-Type: application/json" \\
  -d '{
    "prompt": "A cinematic shot of a banana peeling itself",
    "aspectRatio": "16:9"
  }'`}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Documentation;
